import LockPersonOutlinedIcon from '@mui/icons-material/LockPersonOutlined';
import { Box, Typography } from '@mui/material';

interface AccessDeniedProps {
    permission?: string;
}

const permissionTitle = (permission: string) => {
    return permission
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .replace(/^./, permission[0].toUpperCase());
};

const AccessDenied = ({ permission }: AccessDeniedProps) => {
    return (
        <Box
            component="section"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '50vh',
                p: '10px',
                m: 3,
                textAlign: 'center',
                backgroundImage: 'url(/assets/images/backgrounds/Table.jpg)',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                boxShadow: 3,
                borderRadius: 2,
            }}
        >
            <LockPersonOutlinedIcon
                sx={{
                    fontSize: 64,
                    mb: 2,
                    color: 'error.main',
                }}
            />
            <Typography variant="h5" sx={{ mb: 2 }}>
                You do not have permission to view this page!
            </Typography>
            {permission && (
                <Typography variant="body1">
                    Please contact your administrator and ask for the{' '}
                    <span style={{ fontWeight: 'bold', color: 'primary.main' }}>
                        {permissionTitle(permission)}
                    </span>{' '}
                    permission.
                </Typography>
            )}
        </Box>
    );
};

export default AccessDenied;
